import React from "react";

export default function PasswordStrength({ strength }) {
  if (!strength?.label) return null;
  return (
    <small className={`mt-1 d-inline-block ${strength.cls}`}>
      Strength: {strength.label}
    </small>
  );
}
